import fetchData from '../lib/fetch';

export default {
  fetch() {
    // Fetch data from specified url
    const data = fetchData('./data/metric-100D.json');
    return data;
  },
};
